// extracted by mini-css-extract-plugin
export default {"status":"Status_status__aUk0e","status--ghost":"Status_status--ghost__+MKGq","status--borderless":"Status_status--borderless__mX59f"};